import * as React from "react"

function SvgSocialInstagram(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 23 23"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
      >
        <path d="M6.478 1h10.044A5.478 5.478 0 0122 6.478v10.044A5.478 5.478 0 0116.522 22H6.478A5.478 5.478 0 011 16.522V6.478A5.478 5.478 0 016.478 1z" />
        <path d="M11.5 6a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm6-3a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0117.5 3z" />
      </g>
    </svg>
  )
}

export default SvgSocialInstagram
